export const tableHeaderAsmAsset = (t) => [
  {
    id: 'asset_type',
    type: 'text',
    value: t('asm:tabAsset.table.type'),
  },
  {
    id: 'asset',
    type: 'text',
    value: t('asm:tabAsset.table.asset'),
  },
  {
    id: 'ports',
    type: 'text',
    value: t('asm:tabAsset.table.ports'),
    minWidth: '105px'
  },
  {
    id: 'cdn_names',
    type: 'text',
    value: t('asm:tabAsset.table.cdn'),
    minWidth: '105px'
  },
  {
    id: 'technologies',
    type: 'text',
    value: t('asm:tabAsset.table.technologies'),
    maxSize: 38,
    minWidth: '190px'
  },
  {
    id: 'waf',
    type: 'text',
    value: t('asm:tabAsset.table.waf'),
    minWidth: '105px'
  },
  {
    id: 'webserver',
    type: 'text',
    value: t('asm:tabAsset.table.webserver'),
    maxSize: 38,
    minWidth: '170px'
  },
  {
    id: 'source',
    type: 'text',
    value: t('asm:tabAsset.table.source')
  },
];
